import React, { useState } from 'react';
export function PricingCards() {
  const [selectedPack, setSelectedPack] = useState<1 | 2>(2);
  const packUrls = {
    1: '#checkout-megapack',
    2: '#checkout-quema-x2'
  };
  const packLabels = {
    1: '→ QUIERO EL MEGAPACK — $19.990 ARS',
    2: '→ QUIERO EL MEGAPACK + QUEMA X2 — $27.990 ARS'
  };
  return <div id="pricing" className="bg-brand-deepInk py-16 px-6" data-id="element-233">
      <div className="max-w-[960px] mx-auto" data-id="element-234">
        <span className="block text-[11px] font-bold tracking-[3px] uppercase text-brand-green text-center mb-2.5" data-id="element-235">
          💰 ELEGÍ TU PACK
        </span>
        <h2 className="font-display text-[22px] sm:text-[3.5vw] md:text-[38px] text-center text-white mb-2 uppercase" data-id="element-236">
          Elegí tu <span className="text-brand-green" data-id="element-237">MegaPack</span>
        </h2>
        <div className="green-divider" data-id="element-238"></div>

        <div className="flex flex-col gap-4 max-w-[600px] mx-auto mb-7" data-id="element-239">
          {/* Pack 1 */}
          <div onClick={() => setSelectedPack(1)} className={`bg-white/5 border rounded-xl py-5.5 px-5 cursor-pointer transition-colors flex items-center gap-4 ${selectedPack === 1 ? 'border-brand-green bg-brand-green/5 border-2' : 'border-brand-border'}`} data-id="element-240">
            <div className={`w-[22px] h-[22px] rounded-full border-2 flex items-center justify-center shrink-0 ${selectedPack === 1 ? 'border-brand-green' : 'border-brand-muted'}`} data-id="element-241">
              {selectedPack === 1 && <div className="w-3 h-3 rounded-full bg-brand-green" data-id="element-242"></div>}
            </div>

            <div className="flex-1" data-id="element-243">
              <span className="text-[20px] mb-1 block" data-id="element-244">📦</span>
              <p className="font-display text-base text-white mb-0.5 uppercase" data-id="element-245">
                MegaPack Cuerpo Nuevo después de los 40
              </p>
              <p className="text-[12px] text-brand-muted mb-1" data-id="element-246">
                6 Tomos + 6 Bonos
              </p>
              <p className="text-[12px] text-brand-green font-semibold" data-id="element-247">
                Ideal para: empezar la transformación desde hoy
              </p>
            </div>

            <div className="text-right shrink-0" data-id="element-248">
              <span className="text-[12px] text-[#555] line-through block text-right" data-id="element-249">
                $51.000
              </span>
              <span className={`font-display text-[22px] font-bold whitespace-nowrap ${selectedPack === 1 ? 'text-brand-green' : 'text-white'}`} data-id="element-250">
                $19.990 ARS
              </span>
            </div>
          </div>

          {/* Pack 2 */}
          <div onClick={() => setSelectedPack(2)} className={`bg-white/5 border rounded-xl py-5.5 px-5 cursor-pointer transition-colors flex items-center gap-4 ${selectedPack === 2 ? 'border-brand-green bg-brand-green/5 border-2' : 'border-brand-border'}`} data-id="element-251">
            <div className={`w-[22px] h-[22px] rounded-full border-2 flex items-center justify-center shrink-0 ${selectedPack === 2 ? 'border-brand-green' : 'border-brand-muted'}`} data-id="element-252">
              {selectedPack === 2 && <div className="w-3 h-3 rounded-full bg-brand-green" data-id="element-253"></div>}
            </div>

            <div className="flex-1" data-id="element-254">
              <span className="text-[20px] mb-1 block" data-id="element-255">👑</span>
              <p className="font-display text-base text-white mb-0.5 uppercase" data-id="element-256">
                MegaPack + Quema x2
              </p>
              <p className="text-[12px] text-brand-muted mb-1" data-id="element-257">
                6 Tomos + 6 Bonos + Plan de 21 Días
              </p>
              <p className="text-[12px] text-brand-green font-semibold" data-id="element-258">
                ⭐ Ideal para: resultados acelerados con plan ya armado
              </p>
            </div>

            <div className="text-right shrink-0" data-id="element-259">
              <span className="text-[12px] text-[#555] line-through block text-right" data-id="element-260">
                $69.000
              </span>
              <span className={`font-display text-[22px] font-bold whitespace-nowrap ${selectedPack === 2 ? 'text-brand-green' : 'text-white'}`} data-id="element-261">
                $27.990 ARS
              </span>
            </div>
          </div>
        </div>

        <a href={packUrls[selectedPack]} className="block bg-brand-green text-white font-display text-lg font-bold tracking-[1px] py-4 px-7 rounded-lg text-center uppercase border-none cursor-pointer transition-transform hover:-translate-y-0.5 max-w-[600px] mx-auto shadow-[0_0_24px_rgba(0,200,83,0.25)]" data-id="element-262">
          {packLabels[selectedPack]}
        </a>

        <div className="flex flex-wrap justify-center gap-4 mt-4" data-id="element-263">
          <span className="text-[12px] text-brand-muted" data-id="element-264">
            🔒 Pago 100% seguro
          </span>
          <span className="text-[12px] text-brand-muted" data-id="element-265">
            ⚡ Acceso en 5 minutos
          </span>
          <span className="text-[12px] text-brand-muted" data-id="element-266">
            ✅ Garantía 7 días
          </span>
          <span className="text-[12px] text-brand-muted" data-id="element-267">💳 MercadoPago</span>
        </div>
      </div>
    </div>;
}